import { yupResolver } from '@hookform/resolvers/yup';
import { useCreateAccountMutation } from 'generated/graphql';
import {
  useLoading,
  validationUtil
} from 'modules';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';


const __formSchema = yup.object({
  email: yup.string().email().required('Email is required.'),
  password: validationUtil.passwordSchema.required('Password is required.'),
  confirmPassword: validationUtil.confirmPasswordSchema('password').required('Confirm password is required.')
}).required();

export type IFormData = yup.InferType<typeof __formSchema>;



export function useCreateUserAccountModal(userId: string, defaultEmail: string) {
  const [createAccount, createAccountTuple] = __useCreateAccountMutation(userId);
  const loading = useLoading([createAccountTuple]);

  const form = useForm<IFormData>({
    resolver: yupResolver(__formSchema),
    defaultValues: {
      email: defaultEmail,
      password: '',
      confirmPassword: ''
    }
  });

  return {
    loading,
    form,
    mutations: { createAccount }
  };
}



function __useCreateAccountMutation(userId: string) {
  const [fnMutate, tuple] = useCreateAccountMutation();

  async function fnWrappedMutate(formData: IFormData) {
    await fnMutate({
      variables: {
        input: {
          userId,
          email: formData.email,
          password: formData.password
        }
      }
    });
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
